import { useEffect } from 'react'

import { useAppDispatch } from '~/redux/hooks'
import { declareOracleAvailabilityActionCreator, revokeOracleAvailabilityActionCreator } from '~/redux/slices/chat-ai'

export default function useDeclareOracleAvailability({
  isAvailable,
  hideBottomMenu,
}: {
  isAvailable: boolean
  hideBottomMenu: boolean
}): void {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isAvailable) return

    dispatch(declareOracleAvailabilityActionCreator({ hideBottomMenu }))

    return () => {
      dispatch(revokeOracleAvailabilityActionCreator())
    }
  }, [dispatch, hideBottomMenu, isAvailable])
}
